module.exports = new __parcel__URL__("Logo-X.7956b0c1.svg").toString();